import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BrowserService } from 'src/app/core';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
    private browserService: BrowserService,
  ) {}

  transform(html: any) {
      return this.browserService.checkBrowser() && this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
